export default __webpack_public_path__ + "static/media/zazabor.a83cc524.png";